import {Routes} from '@angular/router';
import {
  AlcoholicSalesPermitBaseInfoSectionComponent
} from './section/alcoholic-sales-permit-base-info-section/alcoholic-sales-permit-base-info-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {EntityType} from '../../../../pipes/entity-type.pipe';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  entityType: EntityType.OSOBA_PRAWNA,
  successUrl: '../zgody',
  cancelUrl: '../informacje-podstawowe'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-identyfikacyjne',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const alcoholicSalesPermitDesktopRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: AlcoholicSalesPermitBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: AlcoholicSalesPermitBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const alcoholicSalesPermitMobileRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: AlcoholicSalesPermitBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: AlcoholicSalesPermitBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const alcoholicSalesPermitRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? alcoholicSalesPermitMobileRoutes : alcoholicSalesPermitDesktopRoutes;
